import React from "react";
import Skeleton from "react-loading-skeleton";

export function ShimmerTable({ row = 10, col = 4, className = "" }) {
  const rows = Array.from({ length: row });
  const cols = Array.from({ length: col });

  // Deterministic width pattern so it looks like real data columns
  const baseWidthsByColCount = {
    4: [34, 22, 18, 26],
    5: [28, 18, 16, 18, 20],
    6: [26, 16, 14, 16, 14, 14],
    7: [22, 14, 14, 16, 12, 12, 10],
    8: [20, 12, 12, 14, 10, 10, 12, 10],
  };
  const baseWidths =
    baseWidthsByColCount[col] ||
    Array.from({ length: col }, () => Math.max(8, Math.floor(100 / col)));

  return (
    <div className={`skeleton-table w-100 ${className}`}>
      {rows.map((_, rIdx) => (
        <div
          key={rIdx}
          className="skeleton-row d-flex align-items-center gap-3"
        >
          {cols.map((__, cIdx) => {
            // Add slight per-row variation so it doesn't look like a barcode
            const wobble = ((rIdx * 7 + cIdx * 11) % 7) - 3; // -3..+3
            const width = Math.max(8, baseWidths[cIdx] + wobble);
            const isPrimaryText = cIdx === 0; // first column usually “name”

            return (
              <div
                key={cIdx}
                className={`skeleton-cell ${isPrimaryText ? "is-primary" : ""}`}
                style={{ width: `${width}%` }}
              >
                <Skeleton height={12} borderRadius={999} />
                {isPrimaryText && rIdx % 3 === 0 && (
                  <div className="mt-2" style={{ width: "70%" }}>
                    <Skeleton height={10} borderRadius={999} />
                  </div>
                )}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
}

